import { CSSResultGroup, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { SlotsNGController as SlotController } from '../../controllers/slots-ng-controller';

import componentStyles from './sic-text-hero.css.lit';

export type containerWidths = 'normal' | 'narrow';

/**
 * The SicTextHero component
 * @slot eyebrow
 * @slot headline
 * @slot subtitle
 *
 * @prop container-width - used to allow for narrow content when needed
 */

@customElement('sic-text-hero')
export class SicTextHero extends OutlineElement {
  slots = new SlotController(this);
  static styles: CSSResultGroup = [componentStyles];

  /**
   * The container width to match the content width.
   */
  @property({
    type: String,
    reflect: true,
    attribute: 'container-width',
  })
  containerWidth: containerWidths = 'normal';

  render(): TemplateResult {
    return html`
      <sic-container
        top-padding="normal"
        bottom-padding="none"
        container-width=${this.containerWidth}
      >
        <div class="text-hero">
          ${this.slots.conditionalSlot('eyebrow')}
          <sic-heading level-size="6">
            ${this.slots.conditionalSlot('headline')}
          </sic-heading>
          <sic-heading level-size="1" class="subtitle">
            <div class="subtitle-wrapper">
              ${this.slots.conditionalSlot('subtitle')}
            </div>
          </sic-heading>
        </div>
      </sic-container>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'sic-text-hero': SicTextHero;
  }
}
